export class QueryFilterModel{
    "siteId":Number;
    "userId":Number;
    "status":String;
}